/**
 * coverage-pe.js  (v2 — reglas Perú completas)
 * Módulo de cobertura por TIERS para iShop Perú.
 *
 * window.iShopCoveragePE: tier(), detalle(), tierDe(lat,lng)
 *
 * detalle() devuelve un objeto unificado con DOS dimensiones independientes:
 *   - recojo: { disponible, estado, segundosRestantes }  (tiers 1,2,4,7)
 *       estado: 'abierto' | 'countdown' | 'urgente' | 'cerrado'
 *   - envio:  { aplica, estado, segundosRestantes, diaLabel } (tiers 1-6)
 *       estado (T1): 'hoy_beneficio' | 'hoy_countdown' | 'hoy_urgente' | 'dia'
 *       estado (T2-6): 'dia'
 *   - tier, estadoGeneral: 'generico' si no hay ubicación
 *
 * Reglas:
 *   ENVÍO (solo L-V hábiles):
 *     T1 mismo día: corte 13:00. Antes de las 10: beneficio sin números;
 *       10:00-12:00 countdown; 12:00-13:00 urgente; pasado 13 o finde -> día hábil.
 *     T2-6: día de entrega = hoy + N hábiles (T2/3=2, T4/5=3, T6=7).
 *   RECOJO (todos los días, incl. feriados):
 *     9:00-17:50 abierto; 17:50-19:50 countdown; 19:50-20:50 urgente;
 *     fuera -> "desde las 10:00 a.m." (día siguiente, prep 9-10am).
 *
 * Config vía window.ANNOUNCEMENT_CONFIG_PE:
 *   corteMismoDia(13), recojoApertura(9), recojoCierre(20.833),
 *   envioCountdownInicio(10), envioUrgenteInicio(12),
 *   recojoCountdownHoras(3), recojoUrgenteHoras(1), feriados[]
 * Hora America/Lima (UTC-5).
 */
(function () {
  'use strict';

  var CFG = window.ANNOUNCEMENT_CONFIG_PE || {};
  function num(v, def) { var n = parseFloat(v); return isFinite(n) ? n : def; }

  var CORTE_MISMO_DIA = num(CFG.corteMismoDia, 13);
  var RECOJO_APERTURA = num(CFG.recojoApertura, 9);
  var RECOJO_CIERRE   = num(CFG.recojoCierre, 20.833);       // 20:50
  var ENVIO_CD_INI    = num(CFG.envioCountdownInicio, 10);   // countdown envío desde 10
  var ENVIO_URG_INI   = num(CFG.envioUrgenteInicio, 12);     // urgente envío desde 12
  var RECOJO_CD_H     = num(CFG.recojoCountdownHoras, 3);    // countdown recojo 3h antes
  var RECOJO_URG_H    = num(CFG.recojoUrgenteHoras, 1);      // urgente recojo 1h antes
  // Vida útil de la lectura GPS (segundos). Si la cookie GPS tiene timestamp y
  // es más reciente que esto, "manda" sobre la tienda elegida. Si está vieja o
  // sin timestamp, la tienda elegida tiene prioridad. Default 6h.
  var GPS_TTL_S       = num(CFG.gpsTtlSegundos, 6 * 3600);

  var COVERAGE = window.ISHOP_PE_COVERAGE || [];

  var FERIADOS = (function () {
    var map = {};
    var list = Array.isArray(CFG.feriados) ? CFG.feriados : null;
    if (list && list.length) {
      list.forEach(function (raw) {
        var ymd = String(raw).trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) map[ymd] = 1;
      });
    }
    if (Object.keys(map).length === 0) {
      ['2026-07-23','2026-07-27','2026-07-28','2026-07-29','2026-08-06',
       '2026-08-30','2026-10-08','2026-11-01','2026-12-08','2026-12-09',
       '2026-12-25'].forEach(function (y) { map[y] = 1; });
    }
    return map;
  })();

  var DIAS = ['DOMINGO','LUNES','MARTES','MIÉRCOLES','JUEVES','VIERNES','SÁBADO'];

  function partsLima(date) {
    var fmt = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Lima',
      year:'numeric', month:'2-digit', day:'2-digit',
      hour:'2-digit', minute:'2-digit', second:'2-digit',
      hour12:false, weekday:'short'
    });
    var p = {};
    fmt.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    var hour = parseInt(p.hour, 10); if (hour === 24) hour = 0;
    var wd = { Sun:0, Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6 };
    return {
      ymd: p.year + '-' + p.month + '-' + p.day,
      hour: hour, minute: parseInt(p.minute,10), second: parseInt(p.second,10),
      dow: wd[p.weekday]
    };
  }

  function esFeriado(ymd) { return !!FERIADOS[ymd]; }
  function esHabil(ymd, dow) { return dow !== 0 && dow !== 6 && !esFeriado(ymd); }

  // entrega = hoy + n días hábiles (no cuenta hoy)
  function masNHabiles(baseDate, n) {
    var d = new Date(baseDate.getTime()), contados = 0;
    for (var i = 0; i < 90; i++) {
      d = new Date(d.getTime() + 86400000);
      var p = partsLima(d);
      if (esHabil(p.ymd, p.dow)) {
        contados++;
        if (contados === n) return { ymd: p.ymd, dow: p.dow };
      }
    }
    return null;
  }

  function esManana(sigYmd, now) {
    var manana = partsLima(new Date(now.getTime() + 86400000)).ymd;
    return sigYmd === manana;
  }

  // Etiqueta del día de entrega. Devuelve { dia, conEl }:
  //   MAÑANA -> { dia:'MAÑANA', conEl:false }
  //   otro   -> { dia:'LUNES', conEl:true }  (el render antepone "el " fuera de la negrita)
  function diaLabel(entrega, now) {
    if (!entrega) return { dia: 'PRONTO', conEl: false };
    if (esManana(entrega.ymd, now)) return { dia: 'MAÑANA', conEl: false };
    return { dia: DIAS[entrega.dow], conEl: true };
  }

  function enAnillo(lng, lat, ring) {
    var inside = false, n = ring.length;
    for (var i = 0, j = n - 1; i < n; j = i++) {
      var xi = ring[i][0], yi = ring[i][1], xj = ring[j][0], yj = ring[j][1];
      if (((yi > lat) !== (yj > lat)) &&
          (lng < (xj - xi) * (lat - yi) / (yj - yi) + xi)) inside = !inside;
    }
    return inside;
  }
  function enPoligono(lng, lat, poly) {
    if (!enAnillo(lng, lat, poly.outer)) return false;
    for (var h = 0; h < poly.holes.length; h++) {
      if (enAnillo(lng, lat, poly.holes[h])) return false;
    }
    return true;
  }
  // Devuelve { tier, nombre } de la primera subzona que contiene el punto.
  function zonaDe(lat, lng) {
    for (var t = 0; t < COVERAGE.length; t++) {
      var cov = COVERAGE[t], b = cov.bbox;
      if (lng < b[0] || lng > b[2] || lat < b[1] || lat > b[3]) continue;
      for (var p = 0; p < cov.polys.length; p++) {
        if (enPoligono(lng, lat, cov.polys[p])) return { tier: cov.tier, nombre: cov.nombre || '', mismoDia: !!cov.mismoDia };
      }
    }
    return null;
  }
  function tierDe(lat, lng) {
    var z = zonaDe(lat, lng);
    return z ? z.tier : null;
  }

  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function storeNumId(raw) {
    if (!raw) return null;
    var m = String(raw).match(/(\d+)\s*$/);
    return m ? m[1] : null;
  }
  var STORES = window.ISHOP_PE_STORES || {};

  // Lee la cookie GPS y devuelve { lat, lng, ts } o null. ts en ms (0 si la
  // cookie es de formato viejo sin timestamp).
  function leerGPS() {
    var raw = getCookie('location_position');
    if (!raw) return null;
    try {
      var pos = JSON.parse(raw);
      var lat = pos && pos.coords && pos.coords.latitude;
      var lng = pos && pos.coords && pos.coords.longitude;
      if (typeof lat === 'number' && typeof lng === 'number') {
        return { lat: lat, lng: lng, ts: (typeof pos.ts === 'number' ? pos.ts : 0) };
      }
    } catch (e) {}
    return null;
  }

  function leerTienda() {
    try {
      if (window.localStorage) {
        var id = storeNumId(localStorage.getItem('preferredStoreId'));
        if (id && STORES[id]) return { lat: STORES[id].lat, lng: STORES[id].lng };
      }
    } catch (e) {}
    return null;
  }

  // Jerarquía: GPS FRESCO manda sobre la tienda elegida.
  //   1) GPS con timestamp dentro de GPS_TTL_S  -> gana (origen 'gps').
  //   2) Tienda elegida (preferredStoreId)       -> origen 'tienda'.
  //   3) GPS viejo / sin timestamp                -> último recurso (origen 'gps').
  //   4) Nada                                     -> null (mensaje genérico).
  function ubicacion() {
    var gps = leerGPS();
    var ahora = Date.now();
    if (gps && gps.ts && (ahora - gps.ts) <= GPS_TTL_S * 1000) {
      return { lat: gps.lat, lng: gps.lng, origen: 'gps' };
    }
    var tienda = leerTienda();
    if (tienda) return { lat: tienda.lat, lng: tienda.lng, origen: 'tienda' };
    if (gps) return { lat: gps.lat, lng: gps.lng, origen: 'gps' };
    return null;
  }

  // Escribe la cookie GPS con timestamp y TTL corto. Dispara el evento que el
  // módulo de la barra ya escucha para repintar.
  function escribirGPS(lat, lng) {
    var payload = JSON.stringify({ coords: { latitude: lat, longitude: lng }, ts: Date.now() });
    // Escribir JSON plano (sin encodeURIComponent) para que coincida con el
    // formato que my-store-locator.js lee con JSON.parse directo. Antes se
    // escribia percent-encoded y el store-locator reventaba en JSON.parse,
    // rompiendo navigation_stripe y el cambio de modelo. leerGPS() aqui sigue
    // funcionando porque getCookie() tolera ambos (decode es no-op en JSON plano).
    document.cookie = 'location_position=' + payload +
      '; path=/; max-age=' + Math.round(GPS_TTL_S) + '; SameSite=Lax';
    try { document.dispatchEvent(new Event('ishop:location-ready')); } catch (e) {}
  }

  // Refresca el GPS SIN volver a pedir permiso, sólo si el usuario ya lo concedió
  // antes ("Allow while visiting the site"). Si el permiso está en 'prompt' no
  // dispara nada (eso queda a un gesto del usuario); si está 'denied', respeta.
  // Usa maximumAge:0 para forzar una lectura nueva y no una cacheada del navegador.
  function refrescarUbicacionSiPermitido(cb) {
    if (!navigator.geolocation) { if (cb) cb(false); return; }
    function pedir() {
      navigator.geolocation.getCurrentPosition(
        function (pos) { escribirGPS(pos.coords.latitude, pos.coords.longitude); if (cb) cb(true); },
        function () { if (cb) cb(false); },
        { maximumAge: 0, timeout: 8000, enableHighAccuracy: false }
      );
    }
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (st) {
        if (st.state === 'granted') pedir();
        else if (cb) cb(false); // 'prompt' o 'denied' -> no forzamos prompt aquí
      }).catch(function () { if (cb) cb(false); });
    } else {
      // Sin Permissions API (Safari viejo): si ya hay cookie GPS asumimos permiso
      // previo y reintentamos; si no, no arriesgamos un prompt automático.
      if (leerGPS()) pedir(); else if (cb) cb(false);
    }
  }

  // Solicita ubicación de forma EXPLÍCITA (para enganchar a un click/gesto del
  // usuario). Aquí sí puede aparecer el prompt si el permiso está en 'prompt'.
  // Limpia la tienda elegida para que el GPS fresco mande de inmediato.
  function solicitarUbicacion(cb) {
    if (!navigator.geolocation) { if (cb) cb(false); return; }
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        try { if (window.localStorage) localStorage.removeItem('preferredStoreId'); } catch (e) {}
        escribirGPS(pos.coords.latitude, pos.coords.longitude);
        if (cb) cb(true);
      },
      function () { if (cb) cb(false); },
      { maximumAge: 0, timeout: 10000, enableHighAccuracy: true }
    );
  }

  // ---- RECOJO: estado según hora (aplica a tiers 1,2,4,7) ----
  function calcRecojo(p) {
    var h = p.hour + p.minute / 60 + p.second / 3600;
    if (h < RECOJO_APERTURA || h > RECOJO_CIERRE) {
      return { disponible: false, estado: 'cerrado', segundosRestantes: 0 };
    }
    var segsAlCierre = Math.round((RECOJO_CIERRE - h) * 3600);
    if (h >= RECOJO_CIERRE - RECOJO_URG_H) return { disponible: true, estado: 'urgente', segundosRestantes: segsAlCierre };
    if (h >= RECOJO_CIERRE - RECOJO_CD_H)  return { disponible: true, estado: 'countdown', segundosRestantes: segsAlCierre };
    return { disponible: true, estado: 'abierto', segundosRestantes: segsAlCierre };
  }

  // ---- ENVÍO: estado según zona/hora/día ----
  // Recibe la ZONA (no el tier) para poder distinguir, dentro de Tier 1, las
  // subzonas con entrega el mismo día (zona.mismoDia) del resto de Tier 1,
  // que entrega el primer día hábil ("MAÑANA" o el nombre del día si mañana
  // es sábado/domingo/feriado).
  function calcEnvio(zona, p, now) {
    var tier = zona.tier;

    // Subzonas mismo-día (Tier 1 marcadas con mismoDia): corte 13:00 hoy.
    if (zona.mismoDia) {
      var h = p.hour + p.minute / 60 + p.second / 3600;
      if (esHabil(p.ymd, p.dow) && h < CORTE_MISMO_DIA) {
        var segsAlCorte = Math.round((CORTE_MISMO_DIA - h) * 3600);
        if (h < ENVIO_CD_INI)  return { aplica: true, estado: 'hoy_beneficio', corteHora: CORTE_MISMO_DIA, segundosRestantes: segsAlCorte };
        if (h >= ENVIO_URG_INI) return { aplica: true, estado: 'hoy_urgente', segundosRestantes: segsAlCorte };
        return { aplica: true, estado: 'hoy_countdown', segundosRestantes: segsAlCorte };
      }
      // pasado corte / finde / feriado -> primer día hábil
      var em = masNHabiles(now, 1);
      return { aplica: true, estado: 'dia', diaLabel: diaLabel(em, now), diaEntregaYmd: em ? em.ymd : null };
    }

    // Resto de Tier 1 -> 1 día hábil (MAÑANA, o siguiente hábil si toca finde/feriado).
    // T2-6 -> N días hábiles según tier.
    var diasEnvio = (tier === 1) ? 1 :
                    (tier === 2 || tier === 3) ? 2 :
                    (tier === 4 || tier === 5) ? 3 : 7;
    var e = masNHabiles(now, diasEnvio);
    return { aplica: true, estado: 'dia', diaLabel: diaLabel(e, now), diaEntregaYmd: e ? e.ymd : null, diasEnvio: diasEnvio };
  }

  function detalle(now, overrideLoc) {
    now = now || new Date();
    var loc = overrideLoc || ubicacion();
    if (!loc) return { tier: null, estadoGeneral: 'generico' };

    var zona = zonaDe(loc.lat, loc.lng);
    if (zona === null) return { tier: null, estadoGeneral: 'generico', origen: loc.origen, lat: loc.lat, lng: loc.lng };
    var tier = zona.tier;

    var p = partsLima(now);
    var conRecojo = (tier === 1 || tier === 2 || tier === 4 || tier === 7);
    var conEnvio  = (tier >= 1 && tier <= 6);

    var d = { tier: tier, nombre: zona.nombre, origen: loc.origen, lat: loc.lat, lng: loc.lng, estadoGeneral: 'ok' };
    if (conRecojo) d.recojo = calcRecojo(p);
    if (conEnvio)  d.envio  = calcEnvio(zona, p, now);
    return d;
  }

  function tier(now) { return detalle(now).tier; }

  // Helper de prueba: arma el detalle para coords/fecha dadas, sin tocar cookies.
  function detalleEn(lat, lng, now) {
    return detalle(now, { lat: lat, lng: lng, origen: 'test' });
  }

  window.iShopCoveragePE = {
    tier: tier, detalle: detalle, tierDe: tierDe, zonaDe: zonaDe, detalleEn: detalleEn,
    refrescarUbicacionSiPermitido: refrescarUbicacionSiPermitido,
    solicitarUbicacion: solicitarUbicacion,
    _partsLima: partsLima, _masNHabiles: masNHabiles, _diaLabel: diaLabel,
    _ubicacion: ubicacion, _leerGPS: leerGPS
  };
})();
